import TagsEditor from './TagsEditor';
export default TagsEditor;
